import { Model } from "@vuex-orm/core"

export default class EventData extends Model {
  static entity = "eventdata"

  static fields() {
    return {
      id: this.string(""),
      name: this.string(""),
      pos: this.number(0),
      year: this.number(0),
    }
  }

  id!: string
  name!: string
  pos!: number
  year!: number
}
